/**
 * Where to send a user after they sign in.
 *
 * Mails link to `/auth/login?redirect=/profile`, so the value is attacker-controllable:
 * resolve it against our own origin and compare, rather than pattern-matching the string.
 * Browsers treat `\` as `/`, so `/\evil.test` is a cross-origin URL that a naive
 * "starts with a single slash" check would wave through.
 */
export function destinationFrom(redirect: string | null): string {
    if (!redirect) {
        return "/";
    }

    try {
        const destination = new URL(redirect, window.location.origin);

        if (destination.origin !== window.location.origin) {
            return "/";
        }

        // We hand the router a path, not a URL, so the origin we just checked is
        // dropped. A path of `//host` would be read back as an authority and leave
        // the platform, so `https://us//evil.test` must not survive the round trip.
        if (destination.pathname.startsWith("//")) {
            return "/";
        }

        return `${destination.pathname}${destination.search}${destination.hash}`;
    } catch {
        return "/";
    }
}
